// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"63e61938","235":"a2340759","355":"2f3cf785","408":"6824fb60","488":"3bd6374d","868":"657372fe"}[chunkId] + ".chunk.js";
};